export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11646.132aa4f2.jpg";